export default __webpack_public_path__ + "static/media/CNC-turning-parts.6b062e4c.webp";